var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"spinner",attrs:{"size":120,"width":17,"color":"green","indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }